import { useState } from 'react';
import {
  ftaMediaTypeData,
  ftaDigitalSubverticalData,
  ftaDigitalVerticalData,
  ftaTvVerticalData,
  ftaTvSubverticalData,
  ftaOohVerticalData,
  ftaOohSubverticalData,
  rsaMediaTypeData,
  rsaDigitalSubverticalData,
  rsaDigitalVerticalData,
  rsaTvVerticalData,
  rsaTvSubverticalData,
  rsaOohVerticalData,
  rsaOohSubverticalData,
} from '@features/benchmarks';
import {
  Box,
  Stack,
  Table,
  TableContainer,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { ComponentProps } from 'react';
import { TableSection } from './TableSection';
import { BENCHMARK_INTRO } from './constants';

const FootTrafficBenchmarkStats = () => (
  <Stack direction="column">
    <TableContainer>
      <Table>
        <TableSection nameLabel="Media Type" data={ftaMediaTypeData} />
        <TableSection
          nameLabel="Digital Vertical"
          data={ftaDigitalVerticalData}
        />
        <TableSection
          nameLabel="Digital Sub Vertical"
          data={ftaDigitalSubverticalData}
        />
        <TableSection nameLabel="TV Vertical" data={ftaTvVerticalData} />
        <TableSection nameLabel="TV Sub Vertical" data={ftaTvSubverticalData} />
        <TableSection nameLabel="OOH Vertical" data={ftaOohVerticalData} />
        <TableSection
          nameLabel="OOH Sub Vertical"
          data={ftaOohSubverticalData}
        />
      </Table>
    </TableContainer>
  </Stack>
);

const RSABenchmarkStats = () => (
  <Stack direction="column">
    <TableContainer>
      <Table>
        <TableSection nameLabel="Media Type" data={rsaMediaTypeData} />
        <TableSection
          nameLabel="Digital Vertical"
          data={rsaDigitalVerticalData}
        />
        <TableSection
          nameLabel="Digital Sub Vertical"
          data={rsaDigitalSubverticalData}
        />
        <TableSection nameLabel="TV Vertical" data={rsaTvVerticalData} />
        <TableSection nameLabel="TV Sub Vertical" data={rsaTvSubverticalData} />
        <TableSection nameLabel="OOH Vertical" data={rsaOohVerticalData} />
        <TableSection
          nameLabel="OOH Sub Vertical"
          data={rsaOohSubverticalData}
        />
      </Table>
    </TableContainer>
  </Stack>
);

const contentOptions: {
  title: string;
  body: React.ReactNode;
  type: BenchmarkProps['defaultType'];
}[] = [
  {
    title: 'Foot Traffic',
    body: <FootTrafficBenchmarkStats />,
    type: 'foot',
  },
  {
    title: 'RSA',
    body: <RSABenchmarkStats />,
    type: 'rsa',
  } as const,
];

type BenchmarkProps = {
  defaultType?: 'foot' | 'rsa';
};

const footerSxProps: ComponentProps<typeof Typography>['sx'] = {
  fontStyle: 'italic',
};

const Benchmarks = (props: BenchmarkProps) => {
  const [benchmarkType, setBenchmarkType] = useState<
    NonNullable<BenchmarkProps['defaultType']>
  >(props.defaultType ?? 'foot');

  const content = contentOptions.find(option => option.type === benchmarkType);

  return (
    <Box id="help_benchmarks" className="tab-pane active" padding={1}>
      <p>{BENCHMARK_INTRO}</p>
      <Stack direction="column" gap="1rem" padding="1rem">
        <FormControl>
          <InputLabel id="benchmark-type">Benchmark Type</InputLabel>
          <Select
            label="Benchmark Type"
            labelId="benchmark-type"
            value={benchmarkType}
            onChange={e =>
              setBenchmarkType(e.target.value as typeof benchmarkType)
            }
          >
            {contentOptions.map(option => (
              <MenuItem key={option.type} value={option.type}>
                {option.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
      {content?.body ?? null}

      <Typography sx={{ marginTop: '0.5rem', ...footerSxProps }}>
        Individual campaign performance may vary
      </Typography>
      <Typography sx={footerSxProps}>
        * Directional with low sample size
      </Typography>
    </Box>
  );
};

export default Benchmarks;
